// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/js/" + chunkId + "." + {"133":"fa20389b","225":"b93d302b","856":"11efc639"}[chunkId] + ".chunk.js");